import { persistor } from '../store/store';

/**
 * Clears all persisted Redux state from local storage
 */
export const clearPersistedState = async () => {
  try {
    // Clear the entire persisted storage
    await persistor.purge();
    
    // Clear any additional local storage items
    localStorage.removeItem('guestUserSessionKey');
    
    // Clear session storage if needed
    sessionStorage.clear();
  } catch (error) {
    console.error('Error clearing persisted state:', error);
    // Fallback: manually clear local storage if purge fails
    localStorage.clear();
    sessionStorage.clear();
  }
};

/**
 * Handles 401 unauthorized errors by clearing persisted state and redirecting to login
 */
export const handle401Error = async () => {
  await clearPersistedState();
  // Use replace instead of href to prevent page refresh issues
  window.location.replace('/login');
};
